module.exports = __webpack_public_path__ + "static/media/hex_fortified_belt.034acadd.png";